import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_imagemaint } from "./shared/data.service";
import { wsImageGroupInfo } from "./shared/wsImageGroupInfo";
import { wsImageLibraryListInfo } from "./shared/wsImageLibraryListInfo";
import { wsImageUploadInfo } from "./shared/wsImageUploadInfo";

import { SchoolInfo } from "./shared/SchoolInfo";
import { ImageEditComponent } from "./imageedit/imageedit.component";
import { ImageAssociationComponent } from "./imageassociation/imageassociation.component";
import { ImageCopyComponent } from "./imagecopy/imagecopy.component";
import { ImageRenameComponent } from "./imagerename/imagerename.component";
import { ImageSetDistrictComponent } from "./imagesetdistrict/imagesetdistrict.component";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-root",
	templateUrl: "./imagemaint.component.html",
	styleUrls: ["./imagemaint.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class ImageMaintComponent implements OnInit, OnDestroy {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_imagemaint,
		private schoolService: SchoolService,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private personselectorService: PersonSelectorService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private title = "Image Maintenance";
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public isDistrictUser: boolean = false;
	public isSU: boolean = false;

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	//	Image Group Selector
	public lstImageGroup: wsImageGroupInfo[] = [];

	//
	//	Set Initial Value for HTML: [disabled]="SelectedImageGroup.UserCanAssociate == false"
	//
	public SelectedImageGroup: wsImageGroupInfo = {
		ImageLibraryGroupID: 8,
		ImageLibraryGroupDesc: "User Defined Images",
		UserCanAssociate: false,
	};

	//	Image List
	public ImageLibraryList: wsImageLibraryListInfo[] = [];

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		if (this.user.UserLevelID == 1) {
			this.isDistrictUser = true;
		} else {
			this.isDistrictUser = false;
		}

		if (this.user.personID == 0) {
			// Is SU
			this.isSU = true;
		} else {
			this.isSU = false;
		}

		this.isBusy = true;
		this.dataService.ImageGroupSelectList().subscribe((data) => this.ImageGroupSelectList_Complete(data));

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageGroupSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageGroupSelectList_Complete(data: any) {
		this.lstImageGroup = data;

		//
		//	Default select (8-User Defined Images)
		//
		this.lstImageGroup.forEach((item) => {
			if (item.ImageLibraryGroupID == 8) {
				this.SelectedImageGroup = item;
			}
		});

		// this.LoadSchoolList();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibrarySelectListByGroupID_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibrarySelectListByGroupID_Complete(data: any) {
		this.ImageLibraryList = data;
		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSelectItem
	//
	//-----------------------------------------------------------------------------------------------------
	onSelectItem(event: any, data: wsImageLibraryListInfo) {
		//
		//	De-Select All Items, But the one Just Selected
		//
		this.ImageLibraryList.forEach((element) => {
			if (element.IsSelected == true && element.ImageLibraryID != data.ImageLibraryID) {
				element.IsSelected = false;
			}
		});

		data.IsSelected = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAdd
	//
	//-----------------------------------------------------------------------------------------------------
	onAdd(event: any) {
		if (this.SelectedSchool.SchoolID > 0) {
			console.log("Starting image load..", new Date().toLocaleTimeString("en-US"));

			if (event.target.files && event.target.files[0]) {
				let reader = new FileReader();

				reader.onload = (e: any) => {
					this.ResizeImageAndUpload(event.target.files[0], e.target.result, 640, this);
				};

				reader.readAsDataURL(event.target.files[0]);
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a school before adding image.",
				header: "School not selected",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEdit
	//
	//-----------------------------------------------------------------------------------------------------
	onEdit() {
		//
		//	Edit Image From Image Library
		//
		if (this.ImageLibraryList.length > 0) {
			var lstFilter = this.ImageLibraryList.filter(function (obj) {
				return obj.IsSelected == true;
			});

			if (lstFilter.length > 0) {
				//
				//	Use the first Item, Should only ever be one item selected at a time.
				//
				if (lstFilter[0].isImageLocked == true && this.isSU == false) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "This image is locked and cannot be edited.",
						header: "Edit Image",
						icon: "fa fa-info",
						accept: () => {},
						reject: () => {},
					});
				} else {
					if (this.isDistrictUser == false && lstFilter[0].SchoolID < 1) {
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "You must have district level access in order to edit a district image.",
							header: "Edit District Image",
							icon: "fa fa-info",
							accept: () => {},
							reject: () => {},
						});
					} else {
						var ref = this.dialogService.open(ImageEditComponent, {
							header: "Edit Image",
							width: "695px",
							data: {
								SelectedItem: lstFilter[0],
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								//
								//	Refresh Image List
								//
								this.isBusy = true;
								this.dataService
									.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
									.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
							}
						});
					}
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRename
	//
	//-----------------------------------------------------------------------------------------------------
	onRename() {
		//
		//	Rename Image From Image Library
		//
		if (this.ImageLibraryList.length > 0) {
			var lstFilter = this.ImageLibraryList.filter(function (obj) {
				return obj.IsSelected == true;
			});

			if (lstFilter.length > 0) {
				//
				//	Use the first Item, Should only ever be one item selected at a time.
				//
				if (lstFilter[0].isImageLocked == true && this.isSU == false) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "This image is locked and cannot be renamed.",
						header: "Rename Image",
						icon: "fa fa-info",
						accept: () => {},
						reject: () => {},
					});
				} else {
					if (this.isDistrictUser == false && lstFilter[0].SchoolID < 1) {
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "You must have district level access in order to rename a district image.",
							header: "Rename District Image",
							icon: "fa fa-info",
							accept: () => {},
							reject: () => {},
						});
					} else {
						var ref = this.dialogService.open(ImageRenameComponent, {
							header: "Rename Image",
							width: "500px",
							data: {
								SelectedItem: lstFilter[0],
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								//
								//	Refresh Image List
								//
								this.isBusy = true;
								this.dataService
									.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
									.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
							}
						});
					}
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDelete
	//
	//-----------------------------------------------------------------------------------------------------
	onDelete() {
		//
		//	Delete Image From Image Library
		//
		if (this.ImageLibraryList.length > 0) {
			var lstFilter = this.ImageLibraryList.filter(function (obj) {
				return obj.IsSelected == true;
			});

			if (lstFilter.length > 0) {
				//
				//	Use the first Item, Should only ever be one item selected at a time.
				//
				if (lstFilter[0].isImageLocked == true && this.isSU == false) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "This image is locked and cannot be deleted.",
						header: "Delete Image",
						icon: "fa fa-info",
						accept: () => {},
						reject: () => {},
					});
				} else {
					if (this.isDistrictUser == false && lstFilter[0].SchoolID < 1) {
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "You must have district level access in order to delete a district image.",
							header: "Delete District Image",
							icon: "fa fa-info",
							accept: () => {},
							reject: () => {},
						});
					} else {
						var message =
							"You are about to delete image [" +
							lstFilter[0].ImageLibraryItemName +
							"].<br><br>" +
							"Please make sure there are no IDcards using this image.<br><br>" +
							"Any associations made to this image will be dropped.<br>" +
							"Click 'Yes' to delete this image (and its associations) or<br>" +
							"Click 'No' to cancel.";

						var header = "Delete District Image";

						if (lstFilter[0].SchoolID > 0) {
							header = "Delete School Image";
						}

						this.confirmationService.confirm({
							message: message,
							header: header,
							icon: "fa fa-info",
							accept: () => {
								//
								//	Do The Delete
								//
								this.isBusy = true;
								this.dataService.ImageLibraryDelete(lstFilter[0].ImageLibraryID).subscribe((data) => this.ImageLibraryDelete_Callback(data));
							},
							reject: () => {},
						});
					}
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryDelete_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryDelete_Callback(data: any) {
		//
		//	Refresh Image List
		//
		this.isBusy = true;
		this.dataService
			.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
			.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCopy
	//
	//-----------------------------------------------------------------------------------------------------
	onCopy() {
		//
		//	Copy Image From Image Library
		//
		if (this.ImageLibraryList.length > 0) {
			var lstFilter = this.ImageLibraryList.filter(function (obj) {
				return obj.IsSelected == true;
			});

			if (lstFilter.length > 0) {
				//
				//	Use the first Item, Should only ever be one item selected at a time.
				//
				if (lstFilter[0].isImageLocked == true && this.isSU == false) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "This image is locked and cannot be copied.",
						header: "Copy Image",
						icon: "fa fa-info",
						accept: () => {},
						reject: () => {},
					});
				} else {
					if (this.isDistrictUser == false && lstFilter[0].SchoolID < 1) {
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "You must have district level access in order to copy a district image.",
							header: "Copy District Image",
							icon: "fa fa-info",
							accept: () => {},
							reject: () => {},
						});
					} else {
						var ref = this.dialogService.open(ImageCopyComponent, {
							header: "Copy Image",
							width: "500px",
							data: {
								SelectedItem: lstFilter[0],
								lstImageGroup: this.lstImageGroup,
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								//
								//	Refresh Image List
								//
								this.isBusy = true;
								this.dataService
									.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
									.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
							}
						});
					}
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetDistrict
	//
	//-----------------------------------------------------------------------------------------------------
	onSetDistrict() {
		//
		//	Set/OnSet Image As District From Image Library
		//
		if (this.ImageLibraryList.length > 0) {
			var lstFilter = this.ImageLibraryList.filter(function (obj) {
				return obj.IsSelected == true;
			});

			if (lstFilter.length > 0) {
				//
				//	Use the first Item, Should only ever be one item selected at a time.
				//
				if (lstFilter[0].isImageLocked == true && this.isSU == false) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "This image is locked and cannot be set.",
						header: "Set Image",
						icon: "fa fa-info",
						accept: () => {},
						reject: () => {},
					});
				} else {
					if (this.isDistrictUser == false) {
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "You must have district level access in order to set image.",
							header: "Set District Image",
							icon: "fa fa-info",
							accept: () => {},
							reject: () => {},
						});
					} else {
						var ref = this.dialogService.open(ImageSetDistrictComponent, {
							header: "Set Image",
							width: "500px",
							data: {
								isSU: this.isSU,
								SchoolID: this.SelectedSchool.SchoolID,
								SelectedItem: lstFilter[0],
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								//
								//	Refresh Image List
								//
								this.isBusy = true;
								this.dataService
									.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
									.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
							}
						});
					}
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAssociate
	//
	//-----------------------------------------------------------------------------------------------------
	onAssociate() {
		if (this.ImageLibraryList.length > 0) {
			var lstFilter = this.ImageLibraryList.filter(function (obj) {
				return obj.IsSelected == true;
			});

			if (lstFilter.length > 0) {
				//
				//	Use the first Item, Should only ever be one item selected at a time.
				//
				var ref = this.dialogService.open(ImageAssociationComponent, {
					header: "Associate Image",
					width: "500px",
					data: {
						SelectedSchool: this.SelectedSchool,
						SelectedGroup: this.SelectedImageGroup,
						SelectedItem: lstFilter[0],
					},
				});
				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh Image List
						//
						this.isBusy = true;
						this.dataService
							.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
							.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
					}
				});
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ResizeImageAndUpload
	//
	//-----------------------------------------------------------------------------------------------------
	ResizeImageAndUpload(imgfile: any, imgfiledata: any, MAX_SIZE: any, _this: this) {
		// Create work image for resizing
		let img = document.createElement("img");

		img.onerror = function () {
			console.log("ERROR: Invalid Image! -> ", imgfile.name);
		};

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let parms: wsImageUploadInfo = {
				SchoolID: _this.SelectedSchool.SchoolID,
				ImageLibraryGroupID: _this.SelectedImageGroup.ImageLibraryGroupID,
				ImageLibraryItemName: imgfile.name,
				ImageUrl: canvas.toDataURL("image/jpeg"),
			};

			console.log("Image load complete..", new Date().toLocaleTimeString("en-US"));

			//
			//	Upload Image
			//
			console.log("Starting image upload..", new Date().toLocaleTimeString("en-US"));
			_this.isBusy = true;
			_this.dataService.ImageLibraryUpload(parms).subscribe((data) => _this.UploadImage_Callback(data));
		};

		// Load The Image Data
		img.src = imgfiledata;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	UploadImage_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	UploadImage_Callback(data: any) {
		console.log("Image upload complete..", new Date().toLocaleTimeString("en-US"));
		//
		//	Refresh Image List
		//
		this.isBusy = true;
		this.dataService
			.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
			.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;
				let isSchoolSelected: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
						isSchoolSelected = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
							isSchoolSelected = true;
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}

				this.isBusy = false;

				if (isSchoolSelected == true) {
					this.isBusy = true;
					this.dataService
						.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
						.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		if (this.SelectedSchool.SchoolID > 0) {
			this.isBusy = true;
			this.dataService
				.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
				.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
		} else {
			this.isBusy = false;
			this.ImageLibraryList = [];
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onImageGroupChange
	//
	//-----------------------------------------------------------------------------------------------------
	onImageGroupChange(value) {
		this.SelectedImageGroup = value;

		if (this.SelectedSchool.SchoolID > 0) {
			this.isBusy = true;
			this.dataService
				.ImageLibrarySelectListByGroupID(this.SelectedSchool.SchoolID, this.SelectedImageGroup.ImageLibraryGroupID)
				.subscribe((data) => this.ImageLibrarySelectListByGroupID_Complete(data));
		} else {
			this.ImageLibraryList = [];
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
